import { io } from "socket.io-client";
import { serverHost } from "./http_common.js";

// Use the same configured origin as the API unless a socket-specific endpoint is set.
// This keeps terminal chat and existing live sales on the same deployed backend.
const socketHost = process.env.REACT_APP_SOCKET_HOST ||
  new URL(serverHost, window.location.origin).origin;
const socket = io(socketHost, {
  autoConnect: false,
  withCredentials: true,
});

export const configureSocketSession = (store, expireSession) => {
  let tokenAtConnection;
  socket.auth = (callback) => {
    tokenAtConnection = store.getState().clientFunction?.sessionToken;
    callback({ sessionToken: tokenAtConnection });
  };
  let previousToken = store.getState().clientFunction?.sessionToken;
  store.subscribe(() => {
    const nextToken = store.getState().clientFunction?.sessionToken;
    if (nextToken === previousToken) return;
    previousToken = nextToken;
    socket.disconnect();
    if (nextToken) socket.connect();
  });
  let lastInteraction = Date.now();
  const interaction = () => {
    lastInteraction = Date.now();
  };
  ["pointerdown", "keydown", "touchstart"].forEach((event) =>
    window.addEventListener(event, interaction, { passive: true }),
  );
  const heartbeat = () => {
    if (socket.connected)
      socket.emit("presence:heartbeat", {
        visible: !document.hidden,
        interacted: Date.now() - lastInteraction < 30000,
        page: "company-account",
      });
  };
  socket.on("connect", heartbeat);
  document.addEventListener("visibilitychange", heartbeat);
  setInterval(heartbeat, 30000);
  if (previousToken) socket.connect();
  socket.on("connect_error", (failure) => {
    if (failure.data?.status === 401)
      expireSession("client", tokenAtConnection);
  });
  socket.on("sessionRejected", (failure) => {
    if (failure.status === 401) expireSession("client", tokenAtConnection);
  });
};

export default socket;
